(function ($) {
  $(document).on('click', '.js-accordion-trigger', function () {
    $(this).next('.js-accordion-content').slideToggle();
    $(this).toggleClass('accordion__title--accordion-open');
    // LazyLoad.update();
    $(document).trigger('accordionChange');
  });
})(jQuery);

